import { useLegacyStore } from "@warp-drive/legacy";
import { JSONAPICache } from "@warp-drive/json-api";
import { DefaultCachePolicy } from "@warp-drive/core/store";
import { setBuildURLConfig } from "@warp-drive/utilities";
import ENV from "glesys-controlpanel/config/environment";
import {
  CachePatchHandler,
  GlesysApiHandler,
  WithStoreAuthToken,
  WithDefaultHeaders,
} from "glesys-controlpanel/data/handlers";

const resources = Object.values(import.meta.glob("../data/*/schema.ts", { eager: true })).map(
  (module) => module.resource,
);

// Lists in `options.listsToPatch` are already patched by CachePatchHandler, so don't mark them stale.
class PatchedListsCachePolicy extends DefaultCachePolicy {
  didRequest(request, response, cacheKey, store) {
    if (
      request.op === "createRecord" &&
      Array.isArray(request.options?.listsToPatch) &&
      request.options.listsToPatch.length
    ) {
      return;
    }

    super.didRequest(request, response, cacheKey, store);
  }
}

setBuildURLConfig({
  host: ENV.apiBaseUri,
  namespace: "",
});

const Store = useLegacyStore({
  linksMode: false,
  cache: JSONAPICache,
  handlers: [WithDefaultHeaders, WithStoreAuthToken, GlesysApiHandler, CachePatchHandler],
  schemas: resources.map((resource) => resource.schema),
  derivations: resources.flatMap((resource) => resource.derivations ?? []),
  policy: new PatchedListsCachePolicy({
    apiCacheHardExpires: 9e5,
    apiCacheSoftExpires: 3e4,
    constraints: { headers: { "X-WarpDrive-Expires": true, "Cache-Control": true, Expires: true } },
  }),
});

export default Store;
